import EmojiRatingPage from "@components/EmojiRatingPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function StyleFeelingPage() {
  if (isHomeDesignFlow()) {
    return (
      <EmojiRatingPage
        translationKey="styleFeelingHomeDesign"
        leftLabelKey="notHappy"
        rightLabelKey="loveIt"
      />
    )
  }
  return (
    <EmojiRatingPage
      translationKey="styleFeeling"
      leftLabelKey="notHappy"
      rightLabelKey="loveIt"
    />
  )
}
